/** TanStack Query keys. Member-dependent public reads include the signed-in user ID. */
export const queryKeys = {
  site: ['site'] as const,
  trips: (region: string | undefined, userId: string | null) =>
    ['trips', { region: region ?? null, userId }] as const,
  trip: (slug: string, userId: string | null) => ['trip', slug, userId] as const,
  pastTrips: ['past-trips'] as const,
  gallery: ['gallery'] as const,
  policies: ['policies'] as const,
  session: ['session'] as const,
  profile: ['me', 'profile'] as const,
  preferences: ['me', 'preferences'] as const,
  myBookings: ['me', 'bookings'] as const,
  booking: (reference: string) => ['booking', reference.toUpperCase()] as const,
  balance: (reference: string) => ['booking', reference.toUpperCase(), 'balance'] as const,
  waitlistOffers: (tripId: string) => ['waitlist', tripId] as const,
};
